import React from 'react';
export function Footer() {
  return <footer className="w-full bg-pine" data-id="element-99" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-100" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-3xl uppercase text-ember" data-id="element-101" data-mp="3ggka709t7m26">
          Small Engine Diagnostic Pro
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-paper/70" data-id="element-102" data-mp="32m1et8sa9itd">
          From no-start to pickup-ready: the shop-ready diagnostic &amp; repair
          system for outdoor power equipment.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-paper/70" data-id="element-103" data-mp="38qtqszerhoj">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-paper hover:underline" data-id="element-104" data-mp="3lem0o69kenno">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-paper hover:underline" data-id="element-105" data-mp="3qcdtr3ly4ftg">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-paper hover:underline" data-id="element-106" data-mp="29xm06nd2d2ik">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-paper/15 pt-5 text-xs leading-relaxed text-paper/50" data-id="element-107" data-mp="2evxb71f3hj2d">
          Independent resource. Not affiliated with or endorsed by any engine
          or equipment manufacturer. Small Engine Diagnostic Pro is a reference
          for professional use: always confirm the manufacturer&apos;s specs and
          procedures, and follow your local safety, emissions and waste rules.
          Never run a generator or engine indoors or in a garage, even with the
          door open. &copy; Small Engine Diagnostic Pro 2026 — All rights
          reserved.
        </p>
      </div>
    </footer>;
}